export default function (http) {
    return {
        queryByPage (data){
            return http.json({
                url: `/sys/question/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },
        getInfo (data){
            return http.json({
                url: `/sys/question/get?id=${data.id}`,
                data
            })
        },
        saveInfo (data){
            return http.json({
                url: `/sys/question/save`,
                data
            })
        },
        delete (data){
            return http.json({
                url: `/sys/question/delete`,
                data
            })
        },

        /**
         * 发布
         * @param data
         * @return {*}
         */
        questionPublish(data) {
            return http({
                url: `/sys/question/publish?id=${data.id}`,
                method: 'post'
            })
        },

        /**
         * 取消发布
         * @param data
         * @return {*}
         */
        questionUnPublish(data) {
            return http({
                url: `/sys/question/unPublish?id=${data.id}`,
                method: 'post'
            })
        },



    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/evaluate.js